import React, { createContext, useState, useEffect, useContext } from 'react';
import Navbar from './components/NavBar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Timeline from './components/Timeline';
import Insights from './components/Insights';
import Courses from './components/Courses';
import AcademicHighlights from './components/AcademicHighlights';
import Contact from './components/Contact';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

function App() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const userLang = navigator.language || navigator.userLanguage;
    setLanguage(userLang.startsWith('zh') ? 'zh' : 'en');
  }, []);

  const toggleLanguage = () => {
    setLanguage(prevLang => prevLang === 'en' ? 'zh' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <Services />
          <About />
          <Timeline />
          <Insights />
          <Courses />
          <AcademicHighlights />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
